module.exports = __webpack_public_path__ + "static/media/28-skikkeleg.374a680f.mp3";